import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { IServiceResponse } from 'src/app/interfaces/IServiceResponse';
import { CDAService } from 'src/app/services/cda.service';
import { SwalToastService } from 'src/app/services/swal.service';

@Component({
  selector: 'app-ips',
  templateUrl: './ips.component.html',
  styleUrls: ['./ips.component.css'],
  standalone: false,
})
export class IpsComponent {
  isLoading: boolean = false;

  inputValue: string =
    'raw.githubusercontent.com/IHE/connectathon-artifacts/main/profile_test_data/PCC/IPS-QEDm/ips-cda/cda-eumfh-43-155-ips.xml';

  prefix: string = 'Https://';

  fileList: NzUploadFile[] = [];

  constructor(
    private readonly cdaService: CDAService,
    private readonly router: Router,
    private readonly swalToastService: SwalToastService
  ) {}

  importByLink() {
    this.isLoading = true;
    this.cdaService
      .uploadXMLlink(encodeURIComponent(this.prefix + this.inputValue))
      .subscribe({
        next: (res: IServiceResponse) => {
          this.isLoading = false;
          this.router.navigate(['/ehr/profile/' + res.message]);
        },
        error: (err) => {
          console.log(err);
          this.swalToastService.toastError('Unable to import CDA');

          this.isLoading = false;
        },
      });
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileList = [file];
    return false; // Prevent automatic upload
  };

  handleChange(): any {
    if (this.fileList.length > 0) {
      this.cdaService.uploadXMLfile(this.fileList[0] as any).subscribe({
        next: (res: IServiceResponse) => {
          this.isLoading = false;
          this.router.navigate(['/ehr/profile/' + res.message]);
        },
        error: (err) => {
          console.log(err);
          this.swalToastService.toastError('Unable to import CDA');

          this.isLoading = false;
        },
      });
      return {
        file: {
          /* ... */
        },
        fileList: [
          /* ... */
        ],
        event: {
          /* ... */
        },
      };
    }
  }
}
